<template>
  <div class="top-header">
    <div class="bg">
      <div class="right-bg"></div>
    </div>
    <el-header class="layout-header">
      <div class="layout-header-logo">
        <!-- <img class="layout-header-logo-img" src="~@/assets/image/logo-zgc.png" alt="" /> -->
         <img class="layout-header-logo-img-new" src="~@/assets/img/logo.png" alt="">
         <span class="logo-name">中关村街道关芯AI智能政务服务系统</span>
         <span class="gap-span"></span>
         <span class="sys-box">关芯智巡</span>
      </div>
      <div class="cur-system">
        <div
          style="display: flex; align-items: center; cursor: pointer"
          @click.stop="backHome"
        ></div>
        <div class="select-box" v-if="listNew.length">
          <div
            v-for="(item, index) in listNew"
            :key="index"
            :class="{ active: selectActive == item.id }"
            class="select-box-item"
            @click="menuListChnage(item)"
          >
            <img
              style="height: 32px; margin-right: 8px"
              :src="require(`@/assets/image/${item.data.menuCode}.png`)"
              alt=""
            />
            <span>{{ item.data.menuName }}</span>
          </div>
        </div>
      </div>
      <div class="layout-header-right">
        <!-- <div class="daping" @click="jump" v-if="listDaping.length">
          <img src="@/assets/image/daping_icon.png" style="margin-right: 5px" />
          <div>可视化大屏</div>
        </div> -->

        <el-popover
          ref="productPopover"
          popper-class="product-matrix-popper"
          placement="bottom"
          :visible-arrow="false"
          width="456"
          trigger="hover">

          <div class="product-matrix-box">
            <img src="~@/assets/img/box_bg.svg" class="product-img" alt="">
            <div class="product-head">中关村街道关芯AI智能政务服务系统</div>
            <div class="product-content">

              <div class="product-item" @click="openProduct(product)" 
                v-for="product in productList" :class="product.disable ? 'product-item-disable':''" :key="product.id">
                <img class="product-ico" :src="product.ico" alt="">
                <div class="product-name">{{ product.name }}</div>
              </div>

            </div>
          </div>

          <img slot="reference" src="~@/assets/img/select_ico_active.svg" alt="">
        </el-popover>

        <span class="gap-span-line"></span>
        <!-- <el-dropdown v-if="listDaping.length" @command="handleCommand">
          <el-button type="primary" class="visualLargeScreen">
            <img
              src="@/assets/image/daping_icon.png"
              style="margin-right: 5px"
            />可视化平台
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">关芯智巡可视化平台1</el-dropdown-item>
            <el-dropdown-item command="b">关芯智巡可视化平台2</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-dropdown>
          <div
            style="
              color: #fff;
              margin-left: 5px;
              margin-right: 10px;
              font-size: 16px;
              display: flex;
              align-items: center;
            "
          >
            <div class="tupian">
              <img style="height: 32px" src="~@/assets/image/touxiang.png" alt="" />
            </div>
            <div
              style="
                height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 150px;
                line-height: 40px;
              "
            >
              {{ userName }}
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="dialogVisible = true">
                <i class="iconfont1 icon-shut-down-line"></i> 修改密码
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="logout">
                <i class="iconfont1 icon-shut-down-line"></i> 退出登录
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <update :dialogVisible="dialogVisible" @close="dialogVisible = false"></update>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import update from './update.vue'
import ico1 from '../../assets/img/box_ico_1.svg'
import ico2 from '../../assets/img/box_ico_2.svg'
import ico3 from '../../assets/img/box_ico_3.svg'
import ico4 from '../../assets/img/box_ico_4.svg'
import ico5 from '../../assets/img/box_ico_5.svg'
import ico6 from '../../assets/img/box_ico_6.svg'
export default {
  components: {
    update
  },
  props: {
    id: {
      type: String || Number,
      default: null,
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      zxCode: null,
      userName: "",
      name: "",
      selectActive: "",
      listNew: [],
      listDaping: [],
      dialogVisible: false,
      productList: [
        { id: 1, name: '关芯客服问答\n（PC端）', ico: ico1, testUrl: 'https://dibrain.wenge.com/wg-agent-client-zgc-gov/#/knowledgeDetails/zgc', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-client/#/knowledgeDetails/zgc' },
        { id: 2, name: '关芯助理问答\n（PC端）', ico: ico2, testUrl: 'https://dibrain.wenge.com/wg-agent-client-zgc-gov/#/knowledgeDetails/zgc-law', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-client/#/knowledgeDetails/zgc-law' },
        { id: 3, name: '关芯客服/助理\n后台管理', ico: ico3, testUrl: 'https://dibrain.wenge.com/wg-agent-manage-zgc-gov/#/login', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-manage/#/login' },
        { id: 4, name: '关芯智巡后台管理', ico: ico4, url: '', disable: true },
        { id: 5, name: '关芯智巡可视化平台\n（小）', ico: ico5, url: 'patrolScreen' },
        { id: 6, name: '关芯智巡可视化平台\n（大）', ico: ico6, url: 'patrolLargeScreen' }
      ]
    };
  },

  created() {
    this.userName = JSON.parse(sessionStorage.getItem("userInfo")).userName;
    this.zxCode = sessionStorage.getItem("zc_code")
    this.listNew = this.list.filter((item) => item.data.menuCode != "patrolScreen");
    this.listDaping = this.list.filter(
      (item) => item.data.menuCode == "patrolScreen" && !item.data.hidden
    );
  },
  methods: {
    openProduct(product) {
      if (product.id === 4) {
        // 不用处理 - 跳转到当前系统后台
        return false;
      }
      const openWindow = () => {
        if (product.id > 3) {
          // 本系统
          if (product.id === 4) {
            // 不用处理 - 跳转到当前系统后台
          } else if (product.url) {
            // 路由跳转 product.url，使用新窗口打开
            const routeUrl = this.$router.resolve({ path: '/' + product.url })
            window.open(routeUrl.href, '_blank')
          }
        } else {
          // 外部系统 - 使用新窗口打开 prodUrl
          if (process.env.NODE_ENV == 'production') {
            if (product.prodUrl) {
              window.open(product.prodUrl+'?zxCode='+encodeURIComponent(this.encryptByAES(this.zxCode)), '_blank')
            }
          } else {
            if (product.testUrl) {
              window.open(product.testUrl+'?zxCode='+encodeURIComponent(this.encryptByAES(this.zxCode)), '_blank')
            }
          }
        }
      }
      const popper = document.querySelector('.product-matrix-popper');
      if (popper) {
        popper.style.display = 'none';
      }
      this.$refs.productPopover.showPopper = false;
      this.$nextTick(() => requestAnimationFrame(openWindow));
    },
    encryptByAES (message) {
        message = message.toString();
        var key = 'u9dYuYlGVk39kkb5';
        var iv = 'LT0cYheDsyKGHENw';
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var ivHex = CryptoJS.enc.Utf8.parse(iv);
        var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
          iv: ivHex,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString();
    },
    menuListChnage(item) {
      if (!item || !item.children.length) return;
      this.selectActive = item.id;
      sessionStorage.setItem("curDefaultActive", "");
      this.$emit("initMenu", item.children);
    },
    logout() {
      sessionStorage.clear(); // 清除权限、用户信息
      localStorage.clear(); // 清除权限、用户信息
      this.$router.push({
        path: "/login",
      });
    },
    jump() {
      this.$router.push({
        path: "/patrolScreen",
      });
    },
    handleCommand(command) {
      command == "a"
        ? this.$router.push({
            path: "/patrolLargeScreen",
          })
        : this.$router.push({
            path: "/patrolScreen",
          });
    },
  },
  computed: {},
  watch: {
    id: {
      handler(val) {
        this.selectActive = this.id;
      },
      deep: true,
    },
    list: {
      handler(val) {
        this.listNew = val.filter((item) => item.data.menuCode != "patrolScreen");
        this.listDaping = val.filter(
          (item) => item.data.menuCode == "patrolScreen" && !item.data.hidden
        );
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="less">
.top-header {
  position: relative;
  height: 64px !important;
  width: 100%;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("~@/assets/image/top-bg.png") no-repeat !important;
    background-size: 100% 100% !important;

    .right-bg {
      position: absolute;
      right: 0;
      top: 0;
      height: 64px;
      width: 1088px;
      background: url("~@/assets/image/top-right-bg.png") no-repeat !important;
      background-size: 100% 100% !important;
    }
  }
}

/deep/.el-dropdown-menu__item:hover {
  background-color: #ebecf0;
  color: #646466;
}

.header-right-i {
  display: inline-block;
  margin-left: 5px;
}

.layout-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 64px !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
}

.layout-header-logo {
  height: 44px;
  display: flex;
  align-items: center;
  span{
    display: inline-block;
  }
  .layout-header-logo-new {
    width: 42px;
    height: 44px;
  }
  .logo-name{
    font-family: Microsoft YaHei;
    font-size: 22px;
    font-weight: bold;
    line-height: 28px;
    color: white;
    white-space: nowrap;
    padding-left: 4px;
  }
  .gap-span{
    width: 2px;
    height: 20px;
    background-color: white;
    margin: 0 12px;
  }
  .sys-box{
    width: 104px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.1);
    font-family: Microsoft YaHei;
    font-size: 20px;
    font-weight: bold;
    color: white;
    text-align: center;
  }
}

.gap-span-line{
  width: 1px;
  height: 18px;
  background-color: white;
  margin: 0 15px;
}
.cur-system {
  width: calc(100% - 440px);
  text-align: left;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.layout-header-logo-img {
  // width: 100%;
  height: 100%;
}

.layout-header-right {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -20px;
  .daping {
    cursor: pointer;
    height: 40px;
    width: 144px;
    background: url("~@/assets/image/daping_btn.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    margin-right: 20px;
  }
}

/deep/ .layout-header .el-input__inner {
  background: none;
  border: none;
  font-family: PingFangSC, PingFang SC;
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
}

/deep/ .layout-header .el-select .el-input .el-select__caret {
  color: #fff;
}

/deep/ .layout-header .el-button--mini {
  height: 28px;
  line-height: 1;
  border-radius: 4px;
  border: 1px solid #ffffff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  background: none;
}

.select-box {
  display: flex;
  align-items: center;
  height: 64px;
  cursor: pointer;

  .select-box-item {
    width: 238px;
    height: 100%;

    font-family: PingFangSC, PingFang SC, bold;
    font-size: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .select-box-item.active {
    background: linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.15) 100%
    );
    position: relative;
  }

  .select-box-item.active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #ffffff;
  }
}

.tupian {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  height: 32px;
  margin-right: 4px;
}

.visualLargeScreen {
  margin-right: 10px;
  background: url("~@/assets/image/daping_btn.png") no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/comp-header/index.vue